import { useGraphPropContext } from "../GraphPropsContext"
import { Line, Text } from "react-konva"
import React from "react"
import { GraphNodeProps } from "../Types"
import { positionFromCenterQuad } from "../../util/fivell_utils"
import _ from "lodash"

export const FiveLLQuadNode: React.FC<GraphNodeProps> = ({ value, hideLabel = false }) => {
  const { lm, pmax } = useGraphPropContext()
  const iconR = lm * 0.1

  if (value.length < 4) {
    console.error("Wrong value:", value)
    return null
  }
  const newValue = value.slice(0, 4)
  const points = _(newValue)
    .map((v, i) => positionFromCenterQuad(lm, (v / 12) * (lm * pmax), i))
    .flatten()
    .value()

  return (
    <>
      <Line points={points} closed stroke="#e7252D" strokeWidth={2} />
      {!hideLabel &&
        newValue.map((v, i) => {
          const rmax = lm * pmax
          const cpr = rmax + iconR * 2
          const [x, y] = positionFromCenterQuad(lm, cpr, i)
          const dimension = { x: x - iconR * 3, y: y, width: iconR * 6, height: lm * 0.08 * 2.4 }
          return (
            <Text
              key={i}
              text={v + ""}
              offsetY={cpr * 0.05}
              {...dimension}
              align="center"
              // verticalAlign="middle"
              fill="#fff"
              fontSize={Math.ceil(lm * 0.1)}
              fontStyle="bold"
            />
          )
        })}
    </>
  )
}
